import r from"styled-components";import{theme as o}from"../../../../theme.js";const e=r.button`
  background-color: unset;
  padding: 0;
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${({active:t})=>t?o.colors.primary[500]:o.colors.gray[400]};
    }
  }
`;export{e as StyledButton};
